import { render } from "./paymentRecords.vue?vue&type=template&id=465eb0c4&scoped=true"
import script from "./paymentRecords.vue?vue&type=script&lang=js"
export * from "./paymentRecords.vue?vue&type=script&lang=js"

import "./paymentRecords.vue?vue&type=style&index=0&id=465eb0c4&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465eb0c4"]])

export default __exports__